export interface ProfileAddress {
  id: string
  label: string
  street: string
  city: string
  postalCode: string
  primary: boolean
}

export interface NotificationChannel {
  id: string
  label: string
  description: string
  enabled: boolean
}

export interface NotificationTopic {
  id: string
  label: string
  description: string
  enabled: boolean
  essential: boolean
}

export interface Consent {
  id: string
  title: string
  purpose: string
  grantedOn: string
  status: 'accorde' | 'a-confirmer'
  withdrawable: boolean
  /** Conséquence affichée avant de confirmer le retrait. */
  withdrawImpact?: string
}

export interface Invoice {
  id: string
  date: string
  service: string
  reference: string
  amount: string
  status: 'payee' | 'a-payer'
}

export interface PolicyDoc {
  id: string
  title: string
  description: string
}

/** Citoyenne fictive. Les rues et les codes postaux sont ceux de Beaconsfield ; les
    numéros civiques et les coordonnées personnelles sont inventés. */
export const profile = {
  firstName: 'Marianne',
  lastName: 'Caldwell',
  initials: 'MC',
  birthDate: '1972-06-18',
  phone: '(514) 694-0210',
  phoneSecondary: '(514) 555-0184',
  email: 'marianne.caldwell@courriel.com',
}

export const addresses: ProfileAddress[] = [
  {
    id: 'principale',
    label: 'Résidence',
    street: '366, chemin Lakeshore',
    city: 'Beaconsfield (Québec)',
    postalCode: 'H9W 4S4',
    primary: true,
  },
  {
    id: 'secondaire',
    label: 'Deuxième propriété',
    street: '130, Taywood Drive',
    city: 'Beaconsfield (Québec)',
    postalCode: 'H9W 5T6',
    primary: false,
  },
]

export const notificationChannels: NotificationChannel[] = [
  { id: 'courriel', label: 'Courriel', description: 'marianne.caldwell@courriel.com', enabled: true },
  { id: 'sms', label: 'SMS', description: '(514) 555-0184', enabled: true },
  { id: 'push', label: 'Notifications mobiles', description: 'Application bciti+', enabled: false },
]

export const notificationTopics: NotificationTopic[] = [
  {
    id: 'alertes',
    label: 'Alertes importantes',
    description: 'Avis d’ébullition, sinistres, mesures d’urgence.',
    enabled: true,
    essential: true,
  },
  {
    id: 'avis',
    label: 'Avis municipaux',
    description: 'Séances du conseil, consultations, avis publics.',
    enabled: true,
    essential: false,
  },
  {
    id: 'services',
    label: 'Services et opérations',
    description: 'Collectes, travaux, déneigement et entraves.',
    enabled: true,
    essential: false,
  },
  {
    id: 'loisirs',
    label: 'Culture et loisirs',
    description: 'Programmation, inscriptions, événements.',
    enabled: false,
    essential: false,
  },
  {
    id: 'rappels',
    label: 'Rappels personnalisés',
    description: 'Échéances de taxes, renouvellements, réservations.',
    enabled: true,
    essential: false,
  },
]

export const consents: Consent[] = [
  {
    id: 'communications',
    title: 'Communications électroniques',
    purpose: 'Recevoir les avis et les communications de la Ville par courriel et par SMS.',
    grantedOn: 'Accordé le 12 mars 2026',
    status: 'accorde',
    withdrawable: true,
  },
  {
    id: 'suivi-requetes',
    title: 'Suivi des requêtes',
    purpose:
      'Être avisée par courriel et par SMS à chaque changement de statut de vos requêtes et lorsque la Ville vous écrit.',
    grantedOn: 'Accordé le 23 septembre 2026',
    status: 'accorde',
    withdrawable: true,
  },
  {
    id: 'personnalisation',
    title: 'Utilisation de mes données pour personnaliser mes services',
    purpose: 'Afficher les collectes, rappels et services correspondant à votre adresse.',
    grantedOn: 'Accordé le 12 mars 2026',
    status: 'accorde',
    withdrawable: true,
  },
  {
    // Beaconsfield fait tourner sa bibliothèque sur SirsiDynix Horizon : ce consentement
    // est ce qui relie la carte citoyenne au dossier d'abonné.
    id: 'partage',
    title: 'Partage de données avec la Bibliothèque',
    purpose:
      'Transmettre votre dossier à la Bibliothèque de Beaconsfield pour créer et tenir à jour votre abonnement.',
    grantedOn: 'Accordé le 21 août 2026',
    status: 'accorde',
    withdrawable: true,
    withdrawImpact: 'Votre abonnement à la Bibliothèque de Beaconsfield ne sera plus mis à jour.',
  },
]

export const invoices: Invoice[] = [
  {
    id: 'f-1042',
    date: '14 août 2026',
    service: 'Camp d’été — 2026',
    reference: 'FAC-1042',
    amount: '285,00 $',
    status: 'a-payer',
  },
  {
    id: 'f-0987',
    date: '2 juillet 2026',
    service: 'Permis de rénovation',
    reference: 'FAC-0987',
    amount: '120,00 $',
    status: 'payee',
  },
  {
    id: 'f-0912',
    date: '3 mars 2026',
    service: 'Taxes municipales — 1er versement',
    reference: 'FAC-0912',
    amount: '1 284,50 $',
    status: 'payee',
  },
]

export const policyDocs: PolicyDoc[] = [
  {
    id: 'vie-privee',
    title: 'Politique de confidentialité',
    description: 'Comment vos renseignements personnels sont protégés et utilisés.',
  },
  {
    id: 'conditions',
    title: 'Conditions d’utilisation',
    description: 'Les règles applicables à l’utilisation des services numériques.',
  },
  {
    id: 'charte-ia',
    title: 'Charte éthique de l’IA',
    description:
      'Nos engagements pour une utilisation responsable, supervisée et transparente de l’intelligence artificielle.',
  },
]

export const atnaQuestions = [
  'Comment mes données sont-elles utilisées ?',
  'Comment modifier mes consentements ?',
  'Comment supprimer mon compte ?',
]
